import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../config/authAxios"



const initialState = { status: null, message: "", loading: false, data: [], error: "" }


export const favoriteMissionAction = createAsyncThunk(
    'add-favoriteMission',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/users/api/favourite-mission`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const favoriteMissionSlice = createSlice({
    name: 'add-favoriteMission',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(favoriteMissionAction.pending, (state) => {
                state.data = []
                state.loading = true
            })
            builder.addCase(favoriteMissionAction.fulfilled, (state, action) => {
                state.data = action.payload.data
                state.loading = false
                state.message = action.payload.message
                state.status = action.payload.status
            })
            builder.addCase(favoriteMissionAction.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload.error
                state.message = action.payload.message
                state.status = action.payload.status
            })
        },

})



export const favoriteMissionReducer = favoriteMissionSlice.reducer